import type { Document } from './dueDiligence';

const emptyNumber = (value: string) => (value.trim() ? Number(value) : null);
export function NumberField({
  label,
  value,
  onChange,
  suffix = '',
  nullable = false,
  max = 100000000,
  min = 0,
}: {
  label: string;
  value: number | null;
  onChange: (value: number | null) => void;
  suffix?: string;
  nullable?: boolean;
  max?: number;
  min?: number;
}) {
  return (
    <label>
      {label}
      <div className="journey-number">
        <input
          aria-label={label}
          type="number"
          min={min}
          max={max}
          step="any"
          value={value ?? ''}
          placeholder={nullable ? 'Noch offen' : ''}
          onChange={(event) => onChange(emptyNumber(event.target.value))}
        />
        <span>{suffix}</span>
      </div>
    </label>
  );
}
export function DocumentSelect({
  documents,
  value,
  onChange,
  label = 'Beleg',
}: {
  documents: Document[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
}) {
  return (
    <label>
      {label}
      <select
        aria-label={label}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        <option value="">Noch kein Beleg</option>
        {documents.map((document) => (
          <option key={document.id} value={document.id}>
            {document.name}
          </option>
        ))}
      </select>
    </label>
  );
}
